export default "__VITE_ASSET__CCSch5uf__"